import { Navigate, useLocation } from 'react-router-dom';

/** Redirect /vendor/* → /hub/* (and pro-hub, admin). */
export function LegacyHubRedirect({ from }: { from: 'vendor' | 'pro-hub' | 'admin' }) {
  const { pathname, search } = useLocation();
  const prefix = from === 'pro-hub' ? '/pro-hub' : `/${from}`;
  const hubBase = from === 'pro-hub' ? '/hub/pro' : `/hub/${from}`;
  const rest = pathname.slice(prefix.length);
  return <Navigate to={`${hubBase}${rest}${search}`} replace />;
}
